module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "restaurant-detail"
  }, [(_vm.showTop) ? _c('div', {
    staticClass: "state-box box"
  }, [(_vm.order.pay_status) ? _c('img', {
    staticClass: "state-img",
    attrs: {
      "src": require("../assets/images/restaurant_suc_icon.png"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "state-img",
    attrs: {
      "src": require("../assets/images/restaurant_err_icon.png")
    }
  }), _vm._v(" "), (_vm.order.pay_status) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("订单完成")]) : _c('div', {
    staticClass: "title"
  }, [_vm._v("支付失败")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [(false) ? _c('div', {
    staticClass: "btn-info",
    on: {
      "click": _vm.toComment
    }
  }, [_vm._v("评价")]) : _vm._e(), _vm._v(" "), (!_vm.order.pay_status) ? _c('div', {
    staticClass: "btn-warn",
    on: {
      "click": _vm.toPay
    }
  }, [_vm._v("立即支付")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-box box"
  }, [_c('div', {
    staticClass: "info-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.order.supplier_name))]), _vm._v(" "), _vm._l((_vm.goodsList), function(item) {
    return _c('div', {
      key: item.skuCode,
      staticClass: "list"
    }, [_c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "data"
    }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.weight) + "克")]), _vm._v(" "), _c('div', [_vm._v("¥" + _vm._s(item.gdAmount))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_c('div', [_vm._v("合计 "), _c('span', [_vm._v("¥" + _vm._s(_vm.order.real_pay))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "order-box box"
  }, [_c('div', {
    staticClass: "order-code"
  }, [_c('div', [_vm._v("托盘编号")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.trayNo))])]), _vm._v(" "), _c('div', {
    staticClass: "order-log"
  }, [_c('div', [_vm._v("绑定时间"), _c('span', [_vm._v(_vm._s(_vm.order.create_time))])]), _vm._v(" "), (_vm.order.payTime) ? _c('div', [_vm._v("解绑时间"), _c('span', [_vm._v(_vm._s(_vm.order.payTime))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("订单编号"), _c('span', [_vm._v(_vm._s(_vm.orderId))])]), _vm._v(" "), _c('div', [_vm._v("下单时间"), _c('span', [_vm._v(_vm._s(_vm.order.create_time))])]), _vm._v(" "), (_vm.order.payTime) ? _c('div', [_vm._v("支付时间"), _c('span', [_vm._v(_vm._s(_vm.order.payTime))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6b2a744c","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/RestaurantDetail.vue
// module id = 448
// module chunks = 7